import React, { PropsWithChildren } from 'react';

import classNames from 'classnames';

import { Icon } from '@components/Icon';

import {
  components,
  OptionProps,
  OptionTypeBase,
} from '@external/react-select';

type Props = {
  optionProps: OptionProps<OptionTypeBase>;
};

const OptionItem = ({ optionProps, children }: PropsWithChildren<Props>) => (
  <components.Option {...optionProps}>
    <div className="flex items-center" data-testid="option">
      <div
        className={classNames(
          'flex items-center justify-center h-5 w-5 mr-3',
          'flex-shrink-0 border pointer-events-none',
          {
            'border-bright-blue-600 bg-bright-blue-600': optionProps.isSelected,
            'border-gray-300': !optionProps.isSelected,
          }
        )}
      >
        {optionProps.isSelected && (
          <Icon name="ui/check" size="16" color="white" />
        )}
      </div>
      {children}
    </div>
  </components.Option>
);

export default OptionItem;
